export default "__VITE_ASSET__d8928243__"